"use client"

import { useNavigate } from "react-router-dom"

const SuccessModal = ({ gifUrl }) => {   // ← Remove orderSuccess prop
  const navigate = useNavigate()

  return (
    <div className="product-modal-overlay">
      <div className="product-success-modal">
        <div className="success-icon">✓</div>
        <h4>
          Order Submitted Successfully!
          <p style={{fontSize:'1rem', color:'red'}}>
            Payment is under verification by the depot. You will be notified once confirmed.
          </p>
        </h4>
      
        <button className="close-btn" onClick={() => navigate("/dashboard")}>
          Close
        </button>
      </div>
    </div>
  )
}

export default SuccessModal